import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

export const LabelControl = styled.label`
    display: block;
    margin-bottom: ${Spacing.XS}px;
`;
